module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-up-left-5d5a862a.svg";